{
  "title": "Conjure Barrage",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "Self (60-foot cone)",
  "components": "V, S, M (one piece of ammunition or a thrown weapon)",
  "duration": "Instantaneous",
  "description": [
    "You throw a nonmagical weapon or fire a piece of nonmagical ammunition into the air to create a cone of identical weapons that shoot forward and then disappear. Each creature in a 60-foot cone must succeed on a Dexterity saving throw. A creature takes 3d8 damage on a failed save, or half as much damage on a successful one. The damage type is the same as that of the weapon or ammunition used as a component."
  ],
  "spellLists": ["ranger"]
}
